module.exports = __webpack_public_path__ + "img/fox.834009c7.svg";